import api from '@pray/shared/utils/api';

import type { MarketingCampaignStatus, MarketingCampaignBudgetType } from './getAllMarketingCampaigns';

export type CreateMarketingCampaignParams = {
  artistId: string;
  name: string;
  description?: string;
  status?: MarketingCampaignStatus;
  budgetType: MarketingCampaignBudgetType;
  totalBudgetCents?: number;
  // The signed retail contract face. Preferred over totalBudgetCents, which is the pre-fee
  // wholesale figure the server derives from this one.
  contractValueCents?: number;
  serviceFeePercent?: number;
  dailyBudgetCents?: number;
  startDate: string;
  endDate?: string;
  // The signed term. startDate/endDate above control delivery and move with it; these mirror the
  // contract and drive revenue recognition. Omitted, the server defaults them to the serving dates.
  contractStartDate?: string;
  contractEndDate?: string;
  placements?: string[];
  platforms?: string[];
};

export const createMarketingCampaign = async ({
  artistId,
  name,
  description,
  status = 'draft',
  budgetType,
  totalBudgetCents,
  contractValueCents,
  serviceFeePercent,
  dailyBudgetCents,
  startDate,
  endDate,
  contractStartDate,
  contractEndDate,
  placements,
  platforms,
}: CreateMarketingCampaignParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns`;

  const body: Record<string, unknown> = {
    name,
    status,
    budget_type: budgetType,
    start_date: startDate,
  };

  if (description) body.description = description;
  if (totalBudgetCents !== undefined) body.total_budget_cents = totalBudgetCents;
  if (contractValueCents !== undefined) body.contract_value_cents = contractValueCents;
  if (serviceFeePercent !== undefined) body.service_fee_percent = serviceFeePercent;
  if (dailyBudgetCents !== undefined) body.daily_budget_cents = dailyBudgetCents;
  if (endDate) body.end_date = endDate;
  if (contractStartDate) body.contract_start_date = contractStartDate;
  if (contractEndDate) body.contract_end_date = contractEndDate;
  if (placements) body.placements = placements;
  if (platforms) body.platforms = platforms;

  const response = await api.executePostRequest(url, body);

  return response.data;
};
